import * as SessionStorage from "@omni/utils/sessionStorage.utils";
import md5 from "md5";

import { PageInfo, UserInfo } from "@/services/tracking/types/analyticsEvent";

const elementHasBeenTracked = (element: HTMLElement): boolean => {
    return element?.dataset?.trackingDone === "true";
};

const setElementHasBeenTracked = (element: HTMLElement): void => {
    if (element?.dataset) element.dataset.trackingDone = "true";
};

const getJsonPayload = (element?: HTMLElement, attribute?: string): any => {
    const dataAttribute = attribute || "trackingInfo";
    const payload = element?.dataset[dataAttribute] || "{}";
    try {
        return JSON.parse(payload) || {};
    } catch {
        console.warn("hubo: unable to parse tracking payload");
    }

    return {};
};

const hasTrackingEventSuffix = (element: HTMLElement, suffix: string) => {
    return element.dataset.trackingEvent?.endsWith(suffix);
};

const findClosestContext = (element: HTMLElement) => {
    const closest = element.closest(
        "[data-tracking-event='section-impression']"
    ) as HTMLElement;

    if (closest) {
        return getJsonPayload(closest, "trackingInfo");
    }
};

const getPageInfo = (): PageInfo => {
    const pageImpressionElement: HTMLElement | null = document.querySelector(
        '[data-tracking-event="page-impression"]'
    );
    if (pageImpressionElement) {
        const pageInfo: Omit<PageInfo, "timestamp"> = getJsonPayload(
            pageImpressionElement
        );

        return {
            name: pageInfo.name,
            url: pageInfo.url,
            locale: pageInfo.locale,
            language: pageInfo.language,
            category: pageInfo.category,
            type: pageInfo.type,
            timestamp: Date.now()
        };
    }
    return {
        name: "",
        url: "",
        locale: "",
        language: "",
        category: "",
        type: "",
        timestamp: Date.now()
    };
};

const createUserId = (email: string) => md5(email);

const getUserInfo = (): UserInfo => {
    const email = SessionStorage.getItem("customer_email");
    if (email) {
        return {
            loginStatus: true,
            clientID: createUserId(email)
        };
    }

    return {
        loginStatus: false
    };
};

export {
    createUserId,
    elementHasBeenTracked,
    findClosestContext,
    getJsonPayload,
    getPageInfo,
    getUserInfo,
    hasTrackingEventSuffix,
    setElementHasBeenTracked
};
